import { render, staticRenderFns } from "./DueLiveTrigger.vue?vue&type=template&id=08f777e4"
import script from "./DueLiveTrigger.vue?vue&type=script&lang=js"
export * from "./DueLiveTrigger.vue?vue&type=script&lang=js"
import style0 from "./DueLiveTrigger.vue?vue&type=style&index=0&id=08f777e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports